import type { User } from "@supabase/supabase-js";
import type { AuthUser } from "./types";

/**
 * The single place that knows Supabase's user field names. Converts the raw
 * provider `User` into our provider-agnostic `AuthUser`. Type-only import of
 * `User` keeps this free of runtime Supabase code, so it is safe to use from
 * both the browser client and the server seam.
 *
 * Swapping providers later = rewrite this one function to map the new
 * provider's profile into the same `AuthUser` shape; every caller is unchanged.
 */
export function toAuthUser(user: User): AuthUser {
  const meta = user.user_metadata ?? {};
  const str = (v: unknown): string => (typeof v === "string" ? v : "");

  return {
    id: user.id,
    email: user.email ?? null,
    emailVerified: !!user.email_confirmed_at,
    phone: user.phone ?? null,
    provider: user.app_metadata?.provider ?? null,
    providers: (user.app_metadata?.providers as string[] | undefined) ?? [],
    metadata: {
      givenName: str(meta.given_name),
      familyName: str(meta.family_name),
      fullName: str(meta.full_name),
    },
    createdAt: user.created_at ?? null,
    lastSignInAt: user.last_sign_in_at ?? null,
  };
}
